// extracted by mini-css-extract-plugin
export var container = "_6h-0";
export var fallback = "_6h-5";
export var fallbackIcon = "_6h-6";
export var hidden = "_6h-2";
export var image = "_6h-3";
export var loaded = "_6h-4";
export var placeholder = "_6h-1";